var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4 49.9635V18.2301C54.4 15.7368 52.36 13.6968 49.8666 13.6968H18.1333C15.64 13.6968 13.6 15.7368 13.6 18.2301V49.9635C13.6 52.4568 15.64 54.4968 18.1333 54.4968H49.8666C52.36 54.4968 54.4 52.4568 54.4 49.9635ZM26.9733 38.5848L31.7333 44.3195L38.76 35.2755C39.2133 34.6861 40.12 34.6861 40.5733 35.2981L48.5293 45.9061C49.096 46.6541 48.552 47.7195 47.6226 47.7195H20.4453C19.4933 47.7195 18.972 46.6315 19.5613 45.8835L25.2053 38.6301C25.636 38.0408 26.4973 38.0181 26.9733 38.5848Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/no_photo.c99364b633ec9dc2dcf76872b0e0dbdd.svg";
export { ForwardRef as ReactComponent };